import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import CaptureAlert from './captureAlert';

describe('Index', () => {
  test('isCaptured', () => {
    render(<CaptureAlert isCaptured={true} isCaptureFail={false} />);

    // screen.debug();
    expect(screen.getByText('画像をキャプチャしました。患者情報編集画面より確認できます。')).toBeInTheDocument();
  });

  test('isCaptured', () => {
    render(<CaptureAlert isCaptured={false} isCaptureFail={true} />);

    // screen.debug();
    expect(screen.getByText('画像のキャプチャに失敗しました。患者画像は10枚まで保存できます。')).toBeInTheDocument();
  });
});
